/*
This file was generated by the Surface compiler.
*/

export { placeSelector } from "../hooks/place_selector_hook"
